import { Nullable } from '../../../../../shared/types';

const depreciationPeriodFormatter = (params: {
  value: Nullable<number>;
}) => {
  return typeof params.value === 'number' ? params.value + ' kk' : '';
};

export default depreciationPeriodFormatter;
